import React, { useEffect, useState, Suspense, lazy } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { EprintRegisterFormDetails } from "./pages/EprintRegisterFormDetails";
import { useTranslation } from "react-i18next";
import { useAuthentication } from "./hooks/auth";
import { useGlobalContext } from "./context/GlobalContext";
import { getCookie } from "./utils/hooks/cookie/getCookie";
import { Loading } from "./components/Loading/Loading";
import { IsFeatureFlagEnabled } from "./services/shopifyFeatureFlag";
import { FeatureFlagRegistry } from "./services/featureFlagRegistry";
import { loadSegmentSnippet } from "./services/analytics";
const EprintRegisterForm = lazy(() => import("./pages/EprintRegisterForm").then(({ EprintRegisterForm }) => ({ default: EprintRegisterForm })),)
const EPrintRegistrationLayout = lazy(() => import("./layout/EprintRegisterForm").then(({ EPrintRegistrationLayout }) => ({ default: EPrintRegistrationLayout })),)

function App() {
  const { t } = useTranslation();
  const { authenticateUser } = useAuthentication();
  const { dispatch } = useGlobalContext();
  const [isLoading, setIsLoading] = useState(true);

  document.title = t("title");

  useEffect(() => {
    loadSegmentSnippet(process.env.REACT_APP_SEGMENT_API_KEY || "");
  }, []);

  useEffect(() => {
    const resolveLocaleFromQuery = () => {
      if (typeof window === "undefined") return "en-CA";
      const params = new URLSearchParams(window.location.search);
      const lng = params.get("lng");
      const normalized = (lng || "").toLowerCase();

      if (normalized.startsWith("fr")) return "fr-CA";
      if (normalized.startsWith("en")) return "en-CA";
      return "en-CA";
    };

    const fetchData = async () => {
      try {
        try {
          const isEmployeeIDFlagEnabled = await IsFeatureFlagEnabled("enableAssociateNoteFlag");
          const isPreferredStoreFlagEnabled = await IsFeatureFlagEnabled("feature_flag_preferred_store_enabled");

          console.log("Feature Flag Enabled:", {
            enableEmployeeIDFlag: isEmployeeIDFlagEnabled,
            feature_flag_preferred_store_enabled: isPreferredStoreFlagEnabled,
          });

          dispatch({type: "SET_IS_EMPLOYEE_ID_FLAG_ENABLED",  isEmployeeIDFlagEnabled});
          dispatch({type: "SET_IS_PREFERRED_STORE_FLAG_ENABLED", isPreferredStoreFlagEnabled});

          // Register the resolved flag so it's sent as an HTTP header on all API calls
          FeatureFlagRegistry.set("enableEmployeeIDFlag",  isEmployeeIDFlagEnabled);
          FeatureFlagRegistry.set("feature_flag_preferred_store_enabled", isPreferredStoreFlagEnabled);
        } catch (err) {
          console.error("Feature Flag Error:", err);
        }
        if (typeof window !== "undefined") {
          const localeFromQuery = resolveLocaleFromQuery();
          dispatch({ type: "SET_LOCALE", locale: localeFromQuery });
          if (window.location.pathname.startsWith("/Account/")) {
            setIsLoading(false);
            return;
          }
        }
        await authenticateUser();
        if (getCookie("StoreId") !== undefined && getCookie("StoreId") !== "") {
          //Online users and not Kiosk.
          dispatch({ type: "LOG_ERROR", error: { show: true, type: "alert", displayErrorMessage: "Print Connect Registration is only though online mode...", rawErrorMessage: "StoreId is not empty, offline user" } })
        }
      } finally {
        setIsLoading(false);
      }
    };

    if (isLoading) fetchData();
  }, []);

  if (isLoading) {
    return <Loading display={true} />;
  }

  return (
    <Suspense fallback={
      <Loading display={true} />
    }>
      <BrowserRouter>
        <Routes>
          <Route path="pages/print-connect-registration-form" element={<EPrintRegistrationLayout />}>
            <Route index element={<EprintRegisterForm />} />
            <Route path="details" element={<EprintRegisterFormDetails />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
